import { IconSvgElement } from "@hugeicons/react";
import { useNotificationContext } from "providers/NotificationProvider";
import { NavLink } from "./NavLink";

interface NotificationLink {
  name: string;
  to: string;
  Icon: IconSvgElement;
}

export const NotificationsNavLink = ({ name, to, Icon }: NotificationLink) => {
  const { totalUnread } = useNotificationContext();

  return (
    <NavLink indicator={totalUnread} to={to} HugeIcon={Icon}>
      {name}
    </NavLink>
  );
};
